module.exports = __webpack_public_path__ + "static/media/anim-3-keyframes.d78af306.png";